import React from "react";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import LockOpenIcon from "@mui/icons-material/LockOpen";
// import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import swal from "sweetalert";

import { makeGetRequest, makePostRequest } from "../../../utils/utils";

import { fetchToken } from "../../firebase.js";
import { useCookies } from "react-cookie";
import Cookies from "js-cookie";
import * as CryptoJS from "crypto-js";

import IconButton from "@mui/material/IconButton";
// import FilledInput from "@mui/material/FilledInput";
// import OutlinedInput from "@mui/material/OutlinedInput";
// import InputLabel from "@mui/material/InputLabel";
// import FormHelperText from "@mui/material/FormHelperText";
// import FormControl from "@mui/material/FormControl";
// import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import dayjs from "dayjs";
import moment from "moment";

function Login() {
  // For Eye
  const [showPassword, setShowPassword] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  // End

  const navigate = useNavigate();
  const secretKey = "12345";

  const encrypt = (plainText) => {
    const cipherText = CryptoJS.AES.encrypt(plainText, secretKey).toString();
    return cipherText;
  };

  const decrypt = (cipherText) => {
    const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
    const plainText = bytes.toString(CryptoJS.enc.Utf8);
    return plainText;
  };

  const ShowForgotDiv = () => {
    var element = document.getElementById("logAndForgot");
    element.classList.toggle("showForgot");
  };

  const [, setTokenFound] = useState(false);
  const [userNameErrorMsg, setUserNameErrorMsg] = useState("");
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");
  const [forgotPasswordErrorMessage, setForgotPasswordErrorMessage] = useState("");
    const [Upload, setUpload] = React.useState(false);


    const [invoice_date] = React.useState(dayjs(new Date()));
    const [, setMaintenenceJsonList] = React.useState([]);
    // const [getLateFee, setgetLateFee] = useState(0);

    
    async function TaxListing() {
      let bodyFormData = {};
  
      await makeGetRequest("tax/getall", bodyFormData)
        .then((response) => {
          if (response.status === 201) {
     
            const data = response.data.data;
            // new change added by me for late fee save
  
            const lateFeeTax = data.find((tax) => tax.tax_name === "Late Fee");
            if (lateFeeTax) {
              // setgetLateFee(lateFeeTax.tax_amount);
              lateFeecalc(lateFeeTax.tax_amount)
            }
          } else {
            setShowLoader(false)
            swal("There was an error!", response.message, "warning");
          }
        })
        .catch((err) => {
          setShowLoader(false)
          swal("There was an error!", "more error details", "warning");
        });
    }


    const lateFeecalc = async (getLateFee) => {
      setShowLoader(true);
      console.log("late fee", getLateFee);
      let inputdata = {
        current_date: invoice_date,
      };
  
      await makePostRequest("invoice/getinvoce", inputdata)
        .then(async (response) => {
          if (response.status == "201") {
            const data = response.data.data;
            console.log("re", response.data.data);
            console.log("len", response.data.data.length);
            if (data.length === 0) {
              setShowLoader(false);
              // swal("No invoices found", "There are no invoices to update.", "");
              return;
            }
  
            const currentDate = moment(invoice_date);
  
            for (let i = 0; i < response.data.data.length; i++) {
              let result = response.data.data[i];
  
              console.log(result);
  
              const dueDate = moment(result.due_date);
              const monthDifference = currentDate.diff(dueDate, "months");
              let maintenanceTotal = 0;
              console.log("diff", monthDifference);
  
              maintenanceTotal = result.maintenance_total;
              console.log("m tot", maintenanceTotal);
              console.log(result.total_payment);
              let lateFee = 0;
              let lateFeeamt = 0;
  
              // lateFee = (maintenanceTotal * (monthDifference + 1)) / getLateFee;
              lateFeeamt = (maintenanceTotal * getLateFee) / 100;
              lateFee = lateFeeamt * (monthDifference + 1);
              console.log("late fee", lateFee);
  
              // let finalfee = lateFee.toFixed(2);
              let totalPay = (maintenanceTotal + lateFee).toFixed(2);
  
              console.log("totalPay", result.maintenence_json_list);
  
              const invId = result.invoice_id;
              let invoicetype = result.invoice_type;
  
              let calculated_Total = result.total_payment.toFixed(2);
              let oldLateFee = 0;
              let filteredmaintenence = result.maintenence_json_list.filter(
                (user) => {
                  if (invoicetype == "Monthly Maintenance") {
                    if (user.key == "Late Fee") {
                      oldLateFee = parseFloat(user.total);
                    } else {
                      return user;
                    }
                  } else {
                    if (user.name == "Late Fee") {
                      oldLateFee = parseFloat(user.total);
                    } else {
                      return user;
                    }
                  }
                }
              );
              console.log("test", filteredmaintenence);
              console.log("Old Late Fee:", oldLateFee);
              // setMaintenenceJsonList(filteredmaintenence);
              let newmaint = filteredmaintenence;
  
              let miscellaneousJson;
              if (invoicetype == "Monthly Maintenance") {
                miscellaneousJson = { key: "", value: "", total: "" };
                miscellaneousJson.key = "Late Fee";
                miscellaneousJson.value = getLateFee;
                miscellaneousJson.total = parseFloat(lateFee.toFixed(2));
              } else {
                miscellaneousJson = { name: "", value: "", total: "" };
                miscellaneousJson.name = "Late Fee";
                miscellaneousJson.value = getLateFee;
                miscellaneousJson.total = parseFloat(lateFee.toFixed(2));
              }
  
              const newjsn = [...filteredmaintenence, miscellaneousJson];
              // maintenenceJsonList.push(newjsn);
  
              setMaintenenceJsonList([]);
              setMaintenenceJsonList((prevList) => [...prevList, newjsn]);
  
              console.log("fin jsn", newjsn);
  
              let fees = parseFloat(calculated_Total) - parseFloat(oldLateFee);
              let newfees = parseFloat(fees) + parseFloat(lateFee.toFixed(2));
              let totalpayamount = newfees.toFixed(2);
              console.log("totalpayamount", totalpayamount);
              // setShowLoader(false);
              // return false;
  
              // update invoice api
  
              let inputdata = {
                invoice_id: invId,
                total_payment: totalpayamount,
                maintenence_json_list: newjsn,
                late_fee: parseFloat(lateFee.toFixed(2)),
              };
              await makePostRequest("invoice/update", inputdata)
                .then((updateResponse) => {
                  if (updateResponse.data.data !== undefined) {
                    // swal(
                    //   "Success",
                    //   "Late fee has been Updated Successully....",
                    //   "success",
                    //   {
                    //     timer: 1000,
                    //     buttons: false,
                    //   }
                    // );
                  }
                })
                .catch((err) => {
                  console.log(
                    `Error updating invoice ${result.invoice_id}: ${err.message}`
                  );
                });
            }
            // swal(
            //   "Success",
            //   "Late fee has been updated successully....",
            //   "success",
            //   {
            //     timer: 1000,
            //     buttons: false,
            //   }
            // );
          } else {
            swal("There was an error!", response.message, "warning");
          }
          setShowLoader(false);
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    };

  async function login() {
    setShowLoader(true)
    setUserNameErrorMsg("");
    setPasswordErrorMsg("");
    if (userName && password) {
      localStorage.clear();

      var inputdata = {
        email_id: userName,
        password: password,
      };

      await makePostRequest("resident/logIn", inputdata).then(
        async (response) => {
          console.log(response);
          if (response !== undefined) {
            console.log(response.data.data);
console.log("first",response.data.data.rows[0])
         

            // swal("Success",""+appToken,'success',{
            //   timer:3000,
            //   buttons:false
            // })

//Cookies Logic Started            
            if (isRememberMe) {
              setCookie("user", userName, { path: window.location.href });
              setCookie("password", encrypt(password), {
                path: window.location.href,
              });
            } else {
              Cookies.remove("user", userName, { path: window.location.href });
              Cookies.remove("password", password, {
                path: window.location.href,
              });
            }
//Cookies Logic End

            let loggedInUser = response.data.data.rows[0];
            let userType = loggedInUser.user_type;
            sessionStorage.setItem("accessToken", response.data.data.token_id);
            sessionStorage.setItem("schema", loggedInUser.schema_name);
            // localStorage.setItem('showAccess',true)
            
            localStorage.setItem(
              "userName",
              loggedInUser.user_obj.first_name +
                " " +
                loggedInUser.user_obj.last_name
            );

            localStorage.setItem(
              "profilePic",
              loggedInUser.user_obj.profile_pic
            );

            // Temporary used for app functionality  Start
            sessionStorage.setItem("userId",loggedInUser.resident_id)
            // Temporary used for app functionality    End


            localStorage.setItem("userId", loggedInUser.resident_id);
            localStorage.setItem("userType", userType);

            if (userType == "SocietyAdmin" || userType == "Admin Owner") {
              console.log("in admin")
              TaxListing()
              
              console.log("Society Admin ", loggedInUser);
              let societyObj = loggedInUser.society[0];
              let buildingList = [];
              buildingList = loggedInUser.building;

              if (societyObj != undefined || societyObj != null) {
                console.log("11111")
                if (loggedInUser.society_id) {
                  console.log("22222")
                  await localStorage.setItem("socityid", societyObj.society_id);
                  localStorage.setItem(
                    "buildingCnt",
                    societyObj.building_count
                  );
                  localStorage.setItem("societyName", societyObj.society_name);
                  localStorage.setItem("societyAddress", societyObj.address);
                  localStorage.setItem("societyContactNo", societyObj.contact);
                  localStorage.setItem("societyEmail", societyObj.email_id);
                  localStorage.setItem("societyCode", societyObj.society_code);

                  var token = await fetchToken(setTokenFound);
                  console.log("token new", token);
                  let appToken=sessionStorage.getItem('appToken')
                  console.log("sess",appToken)
//                   if(appToken) {
// console.log("in if")
                  
//                     token=appToken;}
//                   else {
//                     console.log("in els")
//                     token=token;
//                   }
                  // var fcm_token="";
                  // token.then((currentToken) => {
                  //   fcm_token=currentToken;
                  
                    await updateSociety(societyObj.society_id,societyObj.building_count, buildingList,token);
                  // });
                  // console.log
                  let inputRes={
                    "resident_id":loggedInUser.resident_id,
                    "fcm_token":token
                  } ;
                  await makePostRequest("resident/update",inputRes )
                  .then((response) => {
                      if(response.status=201)
                      {
                        // alert("resident updated")
                        sessionStorage.setItem('appToken',token);
                      }
                   }).catch((err) => {
                    console.log(err);
                    // swal("There was an error!", "more error details", "warning");
                  });
                
                }
              } else {
                console.log(("0000"))
               await localStorage.setItem("socityid", "");
                swal("Success", "Welcome In society", "success", {
                  timer: 1000,
                  buttons: false,
                });
                navigate("/BuildingYes");
              }
            } else if (userType == "SuperAdmin") {
              setShowLoader(false)
              navigate("/allsociety");
            }
          } else {
            setShowLoader(false)
            // swal("Incorrect UserName or Password", "Try Again", "warning");
            setErrorMsg("Username / Password Is Incorrect");
          }
        }
      );

     

    } else {
      // setUserNameErrorMsg("");
      // setPasswordErrorMsg("");
      if (userName == "") setUserNameErrorMsg("Please Enter Email Address");
      if (password == "") setPasswordErrorMsg("Please Enter Password");
    }
  }

  async function updateSociety(society_id,buildingCnt, buildingList,fcm_token) {

    // alert("In Upda te Function "+fcm_token)

    var objSociety = await GetSocietyById(society_id);

    objSociety.fcm_token = fcm_token;
    await makePostRequest("society/update", objSociety)
      .then((response) => {
        console.log("so update",buildingCnt)
        // checked codition if responce is empty
        if (response.data.data !== undefined) {
          if (buildingCnt == 0) {
            swal(
              "Success",
              "Society Is Configured With Basic Details.. ",
              "success",
              {
                timer: 3000,
                buttons: false,
              }
            );
            localStorage.setItem('selectedIndex',1);
            setUpload(!Upload);
            
            navigate("/BuildingYes");
            // navigate("/Dashboard");
          } else if (buildingList[0].building_name) {
            localStorage.setItem("buildingConfigured", true);
            localStorage.setItem('selectedIndex',0);
            setUpload(!Upload);
            // swal(
            //   "Success",
            //   "Society Is Configured With Basic Details.. Please Add Building Details First",
            //   "success",
            //   {
            //     timer: 3000,
            //     buttons: false,
            //   }
            // );
            // navigate("/ConfigureBuilding");

            navigate("/Dashboard");
          } else {
            swal(
              "Success",
              "Society Is Configured With Basic Details.. Please Add Building Details First",
              "success",
              {
                timer: 3000,
                buttons: false,
              }
            );
            localStorage.setItem("buildingConfigured", false);
            localStorage.setItem('selectedIndex',1);
            setUpload(!Upload);
            navigate("/ConfigureBuilding");
          }
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function GetSocietyById(societyId) {
    var societyObj = "";
    var bodyFormData = "";
    await makeGetRequest("society/getbyid/" + societyId, bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          societyObj = response.data.data;
          localStorage.setItem("addedbuildingCnt", response.data.data.building_count);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
    return societyObj;
  }

  const [userName, setUserName] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [forgetEmail, setForgetEmail] = React.useState("");
  const [ErrorMsg,setErrorMsg]=React.useState("");
  // function showPassword() {
  //   var x = document.getElementById("passworsId");
  //   if (x.type === "password") {
  //     x.type = "text";
  //   } else {
  //     x.type = "password";
  //   }
  // }

  async function handleForgetEmail() {
    localStorage.setItem("forgetEmail", forgetEmail);
    setForgotPasswordErrorMessage("");
    if (forgetEmail) {
      var inputdata = {
        email_id: forgetEmail,
      };

      await makePostRequest("resident/forgotPasswordWeb", inputdata)
        .then(async (response) => {
          if (response.data.data !== undefined) {
            // swal(
            //   "Verification code sent to the email please verify..","","Success",
            //   {
            //     timer: 3000,
            //     buttons: false,
            //   }
            // );

            swal(
              "Verification code sent to email address",
              "Please verify",
              "success",
              {
                timer: 3000,
                buttons: false,
              }
            );

            navigate("/SendOtp");
          }
        })
        .catch((err) => {
          setForgotPasswordErrorMessage(
            "Please enter registered email address"
          );
        });
    } else {
      setForgotPasswordErrorMessage(
        "Please enter your registered email address."
      );
    }
  }

  async function handleChangeEmail(email)
  {
    setUserNameErrorMsg("")
    
 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
  {
    setUserName(email);
  }
  else
  {
    setUserName(email);
    setUserNameErrorMsg("Invalid Email Address")
  }

  }

  const [cookies, setCookie] = useCookies(["user", "password"]);
  const [isRememberMe, setIsRememberMe] = useState(true);
  const [fcmToken, setFCMToken] = useState('');

  React.useEffect(() => {
    if (cookies.user) {
      setUserName(cookies.user);
      setPassword(decrypt(cookies.password));
    }

    console.log("Cookie Data ", cookies.name);
 // Access the FCM token from the global window object
   
 const appToken = window.FCMToken;
 console.log('tokn',appToken)
 setFCMToken(appToken || 'No FCM Token Available'); // Set the state with the token value or a default message
 sessionStorage.setItem('appToken',appToken);
//  alert(appToken);
  }, [Upload]);

  return (
    <>
      <div className="loginwrapper">
        <div className="loginLeft" id="logAndForgot">
          <div className="loginBox" id="loginShow">
            <h2>ResiPro</h2>
            <div className="loginInner">
              <div className="bottSection">
                <h3>Login To Your Account</h3>
                {/* <h5>Please Sign In</h5> */}
                <div className="errorField errorFieldFForLogin errorMsgTop">
                {ErrorMsg}</div>
                <Input
                  placeholder="Email Address"
                  className="myInput"
                  startAdornment={
                    <InputAdornment position="start">
                      <MailOutlineIcon />
                    </InputAdornment>
                  }
                  value={userName}
                  onChangeCapture={(e) => handleChangeEmail(e.target.value)}
                />
                <div className="errorField errorFieldFForLogin">
                  {userNameErrorMsg}
                </div>

                <Input
                  placeholder="Password"
                  id="passworsId"
                  className="myInput lessMargin"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChangeCapture={(e) => setPassword(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">
                      <LockOpenIcon />
                    </InputAdornment>
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <div className="errorField errorFieldFForLogin">
                  {passwordErrorMsg}
                </div>

                <div className="forgotLine">
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          defaultChecked
                          onChange={(event) =>
                            setIsRememberMe(event.target.checked)
                          }
                          value={isRememberMe}
                        />
                      }
                      label="Remember Me"
                    />
                  </div>
                  <a onClick={ShowForgotDiv}>Forgot Password?</a>
                </div>
                <Button
                  variant="contained"
                  className="logButton"
                  onClick={login}
                >
                  Sign in
                </Button>

                {/* <p>App TOken {fcmToken}</p> */}
              </div>
            </div>
          </div>

          <div className="loginBox" id="ForgotShow">
            <h2>Society Management</h2>
            <div className="loginInner">
              <div className="bottSection">
                <h3>Forgot Your Password</h3>
                <h5>Please Enter Email Address</h5>
                <Input
                  placeholder="Email Address"
                  className="myInput"
                  value={forgetEmail}
                  startAdornment={
                    <InputAdornment position="start">
                      <MailOutlineIcon />
                    </InputAdornment>
                  }
                  onChange={(e) => {setForgotPasswordErrorMessage("")
    
                  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e.target.value))
                   {
                     setForgetEmail(e.target.value);
                   }
                   else
                   {
                     setForgetEmail(e.target.value);
                     setForgotPasswordErrorMessage("Invalid Email Address")
                   }}}
                />
                <div className="errorField errorFieldFForLogin">
                  {forgotPasswordErrorMessage}
                </div>

                <div className="forgotLine">
                  <div>
                    {/* <FormControlLabel
                      control={<Checkbox defaultChecked />}
                      label="Remember Me"
                    /> */}
                  </div>
                  <a onClick={ShowForgotDiv}>Login Here ?</a>
                </div>
                <Button
                  variant="contained"
                  className="logButton"
                  onClick={() => handleForgetEmail()}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
    
  );
}

export default Login;
